webpackJsonp([0],{

/***/ "+GdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-article"},[_c('h2',[_vm._v("Politique de confidentialité - RGPD")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('legal',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{domProps:{"innerHTML":_vm._s(props.content)}})]}}])}),_vm._v(" "),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/KFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("AHJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3171c538_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("5nDF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3171c538_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/vS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videos"},[(_vm.featuredVideo)?_c('div',{staticClass:"featured-videos"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-7 col-md-12",attrs:{"id":"single-video"}},[_c('article',{staticClass:"post-video"},[_c('div',{staticClass:"video-info dropshd"},[_c('div',{staticClass:"video-embed-box"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.featuredVideo.iframeCode)}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'VideoPage', params: { id: _vm.featuredVideo.id, slug: _vm.featuredVideo.slug } }}},[_c('h2',{staticClass:"title main-head-title"},[_vm._v(_vm._s(_vm.featuredVideo.name))])]),_vm._v(" "),_c('div',{staticClass:"metabox"},[_c('span',{staticClass:"meta-i"},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(_vm._s(_vm.featuredVideo.date))])])],1)])]),_vm._v(" "),(_vm.featuredVideos.length > 0)?_c('div',{staticClass:"col-lg-5 col-md-12"},[_c('div',{staticClass:"row"},_vm._l((_vm.featuredVideos),function(video){return _c('article',{staticClass:"col-lg-6 col-md-6 col-sm-6"},[_c('single-video',{attrs:{"video":video}})],1)}))]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"last-videos"},[_vm._m(0),_vm._v(" "),_c('vimeo-videos',{attrs:{"per_page":21},on:{"onSuccess":_vm.setVideos}}),_vm._v(" "),_c('div',{staticClass:"row auto-clear"},_vm._l((_vm.lastVideos),function(video){return _c('article',{staticClass:"col-lg-3 col-md-6 col-sm-4"},[_c('single-video',{attrs:{"video":video}})],1)})),_vm._v(" "),_c('div',{staticClass:"clearfix spacer"}),_vm._v(" "),(_vm.lastVideos.length > 0)?_c('div',{staticClass:"text-right"},[_c('router-link',{staticClass:"btn btn-primary btn-lg",attrs:{"to":{ name: 'AllVideos', params: { type: 'last', page: 1, title: 'toutes-les-videos' } }}},[_vm._v("Voir plus de vidéos")])],1):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-television",attrs:{"aria-hidden":"true"}}),_vm._v("Dernières vidéos")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Gyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastVideos_vue__ = __webpack_require__("fUxw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42a4f21e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastVideos_vue__ = __webpack_require__("/vS/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastVideos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42a4f21e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LastVideos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5nDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('h2',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-television",attrs:{"aria-hidden":"true"}}),_vm._v("Résultats pour \""+_vm._s(_vm.$route.params.query)+"\"")]),_vm._v(" "),_c('div',{staticClass:"row auto-clear"},[_c('vimeo-videos',{attrs:{"per_page":16,"query":_vm.$route.params.query},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.videos),function(video){return _c('article',{staticClass:"col-lg-3 col-md-6 col-sm-4"},[_c('single-video',{attrs:{"video":video}})],1)})}}])})],1),_vm._v(" "),_c('div',{staticClass:"clearfix spacer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AHJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Singlevideo__ = __webpack_require__("eypv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Search',
  components: { VimeoVideos: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["VimeoVideos"], SingleVideo: __WEBPACK_IMPORTED_MODULE_1__elements_Singlevideo__["a" /* default */] }
});

/***/ }),

/***/ "E6pN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Singlevideo__ = __webpack_require__("eypv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VimeoVideos: __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__["VimeoVideos"], SingleVideo: __WEBPACK_IMPORTED_MODULE_2__elements_Singlevideo__["a" /* default */] },
  name: 'AllVideos',
  methods: {
    setTotal: function setTotal(response) {
      this.total = response.total;
    },
    getTitle: function getTitle(title) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["startCase"])(title);
    }
  },
  computed: {
    title: function title() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["startCase"])(this.$route.params.title);
    },
    scope: function scope() {
      var type = this.$route.params.type;
      if (this.scopes[type]) {
        return '' + this.scopes[type] + (this.$route.params.id || '');
      }

      return null;
    }
  },
  data: function data() {
    return {
      total: 0,
      perPage: 21,
      scopes: {
        portfolios: 'users/itrnews/portfolios/',
        albums: 'albums/',
        last: 'users/itrnews'
      }
    };
  }
});

/***/ }),

/***/ "JZHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-page"},[_c('vimeo-video',{attrs:{"id":_vm.$route.params.id},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.video)?_c('article',{staticClass:"page"},[_c('div',{domProps:{"innerHTML":_vm._s(props.video.iframeCode)}}),_vm._v(" "),_c('div',{staticClass:"spacer"}),_vm._v(" "),_c('h2',{staticClass:"title main-head-title"},[_vm._v(_vm._s(props.video.name))]),_vm._v(" "),_c('div',{staticClass:"page-info"},[_c('div',{staticClass:"metabox"},[_c('span',{staticClass:"meta-i"},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(_vm._s(props.video.date))]),_vm._v(" "),_c('span',{staticClass:"meta-i"},[_c('a',{attrs:{"href":props.video.link,"target":"_blank"}},[_c('i',{staticClass:"fa fa-external-link"}),_vm._v(" Voir sur Vimeo")])])]),_vm._v(" "),_c('ul',{staticClass:"social"},[_c('li',{staticClass:"social-facebook"},[_c('a',{staticClass:"fa fa-facebook social-icons",attrs:{"href":"#"}})]),_vm._v(" "),_c('li',{staticClass:"social-google-plus"},[_c('a',{staticClass:"fa fa-google-plus social-icons",attrs:{"href":"#"}})]),_vm._v(" "),_c('li',{staticClass:"social-twitter"},[_c('a',{staticClass:"fa fa-twitter social-icons",attrs:{"href":"#"}})]),_vm._v(" "),_c('li',{staticClass:"social-youtube"},[_c('a',{staticClass:"fa fa-youtube social-icons",attrs:{"href":"#"}})]),_vm._v(" "),_c('li',{staticClass:"social-rss"},[_c('a',{staticClass:"fa fa-rss social-icons",attrs:{"href":"#"}})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix spacer"}),_vm._v(" "),_c('div',{staticClass:"video-content"},[_c('h2',{staticClass:"title main-head-title"},[_vm._v("Description")]),_vm._v(" "),_c('img',{staticClass:"video-thumbnail",attrs:{"src":props.video.pictures.sizes[2].link,"align":"left"}}),_vm._v(" "),(props.video.description)?_c('div',_vm._l((props.video.description.split('\n')),function(text){return _c('p',[_vm._v("\n              "+_vm._s(text)),_c('br')])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix spacer"})]):_vm._e()]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jr+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c91d698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("lGCo");
function injectStyle (ssrContext) {
  __webpack_require__("fbbJ")
  __webpack_require__("wbTO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c91d698"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c91d698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MOem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post post-medium"},[_c('div',{staticClass:"thumbr"},[_c('router-link',{staticClass:"afterglow post-thumb",attrs:{"to":{ name: 'VideoPage', params: { id: _vm.video.id, slug: _vm.video.slug } }}},[_c('span',{staticClass:"play-btn-border",attrs:{"title":"Play"}},[_c('i',{staticClass:"fa fa-play-circle headline-round",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"cactus-note ct-time font-size-1"},[_c('span',[_vm._v(_vm._s(_vm.video.durationString))])]),_vm._v(" "),_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.video.pictures.sizes[5].link,"alt":"#"}})])],1),_vm._v(" "),_c('div',{staticClass:"infor"},[_c('h4',[_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'VideoPage', params: { id: _vm.video.id, slug: _vm.video.slug } }}},[_vm._v("\n        "+_vm._s(_vm.video.shortTitle)+"\n      ")])],1),_vm._v(" "),_c('span',{staticClass:"posts-txt",attrs:{"title":"Likes"}}),_vm._v(" "),_c('div',{staticClass:"ratings"},[_c('p',[_vm._v(_vm._s(_vm.video.date))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__("ju79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "PSuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-videos"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('hr'),_c('br'),_vm._v(" "),_c('vimeo-videos',{attrs:{"per_page":_vm.perPage,"page":_vm.$route.params.page,"scope":_vm.scope},on:{"onSuccess":_vm.setTotal},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"row auto-clear"},_vm._l((props.videos),function(video){return _c('article',{staticClass:"col-lg-3 col-md-6 col-sm-4"},[_c('single-video',{attrs:{"video":video}})],1)}))]}}])},[_c('div',{staticClass:"clearfix spacer"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[(_vm.total > 0 && _vm.$route.params.page > 1)?_c('router-link',{staticClass:"btn btn-primary btn-lg",attrs:{"to":{ name: 'AllVideos', params: { page: _vm.$route.params.page - 1 } }}},[_vm._v("\n        Page précédente\n      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[(_vm.perPage * _vm.$route.params.page < _vm.total)?_c('router-link',{staticClass:"btn btn-primary btn-lg",attrs:{"to":{ name: 'AllVideos', params: { page: _vm.$route.params.page + 1 } }}},[_vm._v("\n        Page suivante\n      ")]):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QeW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllVideos_vue__ = __webpack_require__("E6pN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_306d3e79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllVideos_vue__ = __webpack_require__("PSuL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllVideos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_306d3e79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AllVideos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rkgy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SingleVideo',
  props: {
    video: { type: Object, required: true }
  }
});

/***/ }),

/***/ "RwQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RGPD',
  components: { Legal: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["Legal"] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LastVideos__ = __webpack_require__("0Gyy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AllVideos__ = __webpack_require__("QeW/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoPage__ = __webpack_require__("q8u7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RGPD__ = __webpack_require__("okdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Search__ = __webpack_require__("/KFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OldVideoPage__ = __webpack_require__("eSjZ");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_LastVideos__["a" /* default */]
  }, {
    path: '/videos/:type/:id?/:page/:title',
    name: 'AllVideos',
    component: __WEBPACK_IMPORTED_MODULE_3__components_AllVideos__["a" /* default */]
  }, {
    path: '/videos/:id/:slug',
    name: 'VideoPage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_VideoPage__["a" /* default */]
  }, {
    path: '/video/:id/:slug',
    name: 'OldVideoPage',
    component: __WEBPACK_IMPORTED_MODULE_7__components_OldVideoPage__["a" /* default */]
  }, {
    path: '/:query?',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Search__["a" /* default */]
  }, {
    path: '/rgpd',
    name: 'RGPD',
    component: __WEBPACK_IMPORTED_MODULE_5__components_RGPD__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Z7Cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Social',
  mounted: function mounted() {
    this.pageUrl = window.location.href;
  },
  data: function data() {
    return {
      pageUrl: ''
    };
  }
});

/***/ }),

/***/ "ZmOL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__ = __webpack_require__("Z7Cg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db745436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__ = __webpack_require__("sxyd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db745436_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eSjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OldVideoPage_vue__ = __webpack_require__("g71f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_092fb95a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OldVideoPage_vue__ = __webpack_require__("hyYr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OldVideoPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_092fb95a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OldVideoPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eypv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Singlevideo_vue__ = __webpack_require__("Rkgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c71a602a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Singlevideo_vue__ = __webpack_require__("MOem");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Singlevideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c71a602a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Singlevideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fUxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Singlevideo__ = __webpack_require__("eypv");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LastVideos',
  components: { VimeoVideos: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["VimeoVideos"], SingleVideo: __WEBPACK_IMPORTED_MODULE_1__elements_Singlevideo__["a" /* default */] },
  methods: {
    setVideos: function setVideos(_ref) {
      var videos = _ref.data;

      this.featuredVideo = videos.concat().splice(0, 1)[0];
      this.featuredVideos = videos.concat().splice(1, 4);
      this.lastVideos = videos.concat().splice(5, videos.length);
    }
  },
  data: function data() {
    return {
      featuredVideo: null,
      featuredVideos: [],
      lastVideos: []
    };
  }
});

/***/ }),

/***/ "fbbJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g71f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OldVideoPage',
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["makeRequest"])('vimeo/old-id/' + this.$route.params.id).then(function (response) {
      var video = response.data;
      if (video.id !== null) {
        _this.$router.push({ name: 'VideoPage', params: { id: video.id, slug: _this.$route.params.slug } });
      } else {
        _this.error = 'Vidéo non trouvée';
      }
    }).catch(function () {
      _this.error = 'Vidéo non trouvée';
    });
  },
  data: function data() {
    return {
      error: null
    };
  }
});

/***/ }),

/***/ "hyYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"center"},[_c('h2',[_vm._v(_vm._s(_vm.error))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lGCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid standard-bg",attrs:{"id":"home1"}},[_c('div',{staticClass:"row header-top"},[_c('div',{staticClass:"col-lg-3 col-md-6 col-sm-5 col-xs-8"},[_c('router-link',{staticClass:"main-logo",attrs:{"to":{ name: 'Home' }}},[_c('img',{staticClass:"main-logo img-responsive",attrs:{"src":"/static/img/itrtv-logo.jpg","alt":"ITRTV","title":"ITRTV - La télé du numérique"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-9 hidden-md text-right hidden-sm hidden-xs"},[_c('br'),_vm._v(" "),_c('ad',{attrs:{"format":"header"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row home-mega-menu "},[_c('div',{staticClass:"col-md-12"},[_c('nav',{staticClass:"navbar navbar-default"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse js-navbar-collapse megabg dropshd "},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Accueil")])],1)]),_vm._v(" "),_c('social'),_vm._v(" "),_c('div',{staticClass:"search-block"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.searchVideos($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"type":"search","placeholder":"Rechercher"},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}})])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2 hidden-sm hidden-xs"},[_c('aside',{staticClass:"dark-bg"},[_c('article',[_vm._m(1),_vm._v(" "),_c('vimeo-channels',{attrs:{"scope":"portfolios"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('ul',{staticClass:"sidebar-links"},_vm._l((props.data),function(portfolio){return _c('li',{staticClass:"fa fa-chevron-right"},[_c('router-link',{attrs:{"to":{ name: 'AllVideos', params: { type: 'portfolios', id: portfolio.id, page: 1, title: _vm.getCategoryTitle(portfolio.name) } }}},[_vm._v(_vm._s(portfolio.name))])],1)}))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"clearfix spacer"}),_vm._v(" "),_c('article',[_vm._m(2),_vm._v(" "),_c('vimeo-channels',{attrs:{"scope":"albums"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('ul',{staticClass:"sidebar-links"},_vm._l((props.data),function(album){return _c('li',{staticClass:"fa fa-chevron-right"},[_c('router-link',{attrs:{"to":{ name: 'AllVideos', params: { type: 'albums', id: album.id, page: 1, title: _vm.getCategoryTitle(album.name) } }}},[_vm._v(_vm._s(album.name))])],1)}))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"clearfix spacer"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('section',{attrs:{"id":"home-main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9 col-md-12 col-sm-12"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 hidden-md col-sm-12 text-center top-sidebar"},[_c('div',{staticClass:"subscribe-box"},[_vm._m(3),_vm._v(" "),_c('add-subscriber',{ref:"addSubscriber",attrs:{"broadcastChannel":"ITRTV"}}),_vm._v(" "),_c('form',{attrs:{"name":"search-submit","id":"subscribe-submit"},on:{"submit":function($event){$event.preventDefault();_vm.subscribe($event)}}},[_c('fieldset',{staticClass:"search-fieldset"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subscriberEmail),expression:"subscriberEmail"}],staticClass:"search-field",attrs:{"id":"subscribe","type":"text","name":"search","size":"12","placeholder":"Votre adresse email"},domProps:{"value":(_vm.subscriberEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subscriberEmail=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"subscribe-btn",attrs:{"type":"submit","title":"Newsletter"}},[_vm._v("S'abonner")])])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'RGPD' }}},[_vm._v("Voir la politique de confidentialité")])],1)],1),_vm._v(" "),_c('a',{staticClass:"banner-l hidden-sm hidden-xs"},[_c('ad',{attrs:{"format":"sidebar"}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"container text-center",attrs:{"id":"bottom-banner"}},[_c('a',{staticClass:"banner-xl"},[_c('ad',{attrs:{"format":"header"}})],1)]),_vm._v(" "),_c('div',{staticClass:"container-fluid footer-background",attrs:{"id":"footer"}},[_c('div',{staticClass:"container"},[_c('footer',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"row auto-clear"},[_c('div',{staticClass:"col-md-12"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('social')],1),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('h2',{staticClass:"title"},[_vm._v("Les plus partagées")]),_vm._v(" "),_c('vimeo-videos',{attrs:{"per_page":4,"sort":"likes","page":1},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('ul',{staticClass:"footer-menu-links"},_vm._l((props.videos),function(video){return _c('li',[_c('router-link',{attrs:{"to":{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }}},[_vm._v(" "+_vm._s(video.name))])],1)}))]}}])})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('h2',{staticClass:"title"},[_vm._v("Interviews")]),_vm._v(" "),_c('div',{staticClass:"row auto-clear"},[_c('vimeo-videos',{attrs:{"per_page":6,"query":"interview","page":1},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm._l((props.videos),function(video){return _c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6 post post-medium"},[_c('div',{staticClass:"thumbr"},[_c('router-link',{staticClass:"post-thumb",attrs:{"to":{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }}},[_c('span',{staticClass:"play-btn-border",attrs:{"title":"play"}},[_c('i',{staticClass:"fa fa-play-circle headline-round",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"cactus-note ct-time font-size-1"},[_c('span',[_vm._v(_vm._s(video.durationstring))])]),_vm._v(" "),_c('img',{staticClass:"img-responsive",attrs:{"src":video.pictures.sizes[2].link,"alt":"#"}})])],1)])})}}])})],1)]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('h2',{staticClass:"title"},[_vm._v("Les plus vues")]),_vm._v(" "),_c('vimeo-videos',{attrs:{"per_page":4,"sort":"plays","page":1},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('ul',{staticClass:"footer-menu-links"},_vm._l((props.videos),function(video){return _c('li',[_c('router-link',{attrs:{"to":{ name: 'VideoPage', params: { id: video.id, slug: video.slug } }}},[_vm._v(" "+_vm._s(video.name))])],1)}))]}}])})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row copyright-bottom text-center"},[_c('site-footer',{staticClass:"inline"}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{ name: 'RGPD' }}},[_vm._v("Voir la politique de confidentialité")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(5)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":".js-navbar-collapse"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Activer/Désactiver navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-flash",attrs:{"aria-hidden":"true"}}),_vm._v("Actualités")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-gears",attrs:{"aria-hidden":"true"}}),_vm._v("Tendances")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-plug",attrs:{"aria-hidden":"true"}}),_vm._v("S'abonner")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',[_c('b',[_vm._v("Groupe ITRnews")]),_c('br'),_vm._v("\n                  Carré des Archives"),_c('br'),_vm._v("\n                  75 rue des Archives"),_c('br'),_vm._v("\n                  75003 Paris\n                  "),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Pour nous contacter :")]),_c('br'),_vm._v("\n                  Tél : 01 40 16 10 77\n                  "),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Publicité")]),_c('br'),_vm._v("\n                  Tél : 01 40 16 18 48"),_c('br'),_vm._v("\n                  Fax : 01 49 95 00 23"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:publicite@itrtv.com","target":"_blank"}},[_vm._v("Contactez nous par mail")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Rédaction")]),_c('br'),_vm._v("\n                  Tél : 01 40 16 18 55"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:redaction@itrtv.com","target":"_blank"}},[_vm._v("Contactez nous par mail")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"footer-logo",attrs:{"title":"ITRTV"}},[_c('img',{staticClass:"img-responsive text-center",attrs:{"src":"/static/img/itrtv-logo.jpg","alt":"ITRTV"}})]),_vm._v(" "),_c('p',[_vm._v("© Copyright 2017. Tous droits réservés. ITRTV")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "okdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RGPD_vue__ = __webpack_require__("RwQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec7ea84e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RGPD_vue__ = __webpack_require__("+GdD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RGPD_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec7ea84e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RGPD_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q8u7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPage_vue__ = __webpack_require__("t4jg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6584016c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPage_vue__ = __webpack_require__("JZHH");
function injectStyle (ssrContext) {
  __webpack_require__("Jr+o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6584016c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6584016c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sxyd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"social"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"social-google-plus"},[_c('a',{staticClass:"fa fa-google-plus social-icons",attrs:{"href":("https://plus.google.com/share?url=" + _vm.pageUrl),"target":"_blank"}})]),_vm._v(" "),_c('li',{staticClass:"social-twitter"},[_c('a',{staticClass:"fa fa-twitter social-icons",attrs:{"href":("https://twitter.com/home?status=" + _vm.pageUrl),"target":"_blank"}})]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"social-facebook"},[_c('a',{staticClass:"fa fa-facebook social-icons",attrs:{"href":"https://www.facebook.com/sharer/sharer.php","target":"_blank"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"social-rss"},[_c('a',{staticClass:"fa fa-rss social-icons",attrs:{"href":"http://rss.itrtv.com","target":"_blank"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t4jg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VimeoVideo: __WEBPACK_IMPORTED_MODULE_0_itrnews_vuejs_api__["VimeoVideo"] },
  name: 'VideoPage'
});

/***/ }),

/***/ "wbTO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__ = __webpack_require__("13tH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_Social__ = __webpack_require__("ZmOL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    VimeoVideos: __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__["VimeoVideos"],
    VimeoChannels: __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__["VimeoChannels"],
    Ad: __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__["Ad"],
    SiteFooter: __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__["SiteFooter"],
    AddSubscriber: __WEBPACK_IMPORTED_MODULE_1_itrnews_vuejs_api__["AddSubscriber"],
    Social: __WEBPACK_IMPORTED_MODULE_2__components_elements_Social__["a" /* default */]
  },
  methods: {
    subscribe: function subscribe(event) {
      event.preventDefault();
      this.$refs.addSubscriber.sendRequest(this.subscriberEmail);
    },
    searchVideos: function searchVideos(event) {
      event.preventDefault();
      this.$router.push({ name: 'Search', params: { query: this.query } });
    },
    getCategoryTitle: function getCategoryTitle(title) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["kebabCase"])(title);
    }
  },
  data: function data() {
    return {
      subscriberEmail: '',
      query: ''
    };
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.419fd74e8f8978e0c639.js